import React, { useContext, useEffect, useState } from 'react'

import { toast } from 'react-toastify'

import UserContext from 'contexts/UserContext'
import ImageUserUpdate from './imageUserUpdate'
import { usersUpdateAvatar } from 'requests/user'
import Avatar from 'components/avatar'

const SettingProfileFirstPart = () => {

  const { user, setUser } = useContext(UserContext)

  const [updateImageUser, setUpdateImageUser] = useState(false)
  const [avatarUser, setAvatarUser] = useState(false)
  const [newImage, setNewImage] = useState(user?.user.avatar)
  const [avatarId, setAvatarId] = useState(newImage)

  const [ msgValid, setMsgValid] = useState(false)

  const closeModalImageUser = () => {
     setUpdateImageUser(false)

  }
  const handleImageClick = (index: number) => {
    setAvatarId(index)
  
  }
  useEffect(()=>{
    const fetchUpdateDatat = async ()=>{
      setAvatarId(user?.user.avatar)
    }
    fetchUpdateDatat()
  },[updateImageUser])

 


  const updateAvatar = async () => {
    const id = user?.user?._id
    const token = user?.token?.accessToken
    setMsgValid(true)
    try {
      const response = await usersUpdateAvatar(id, avatarId || undefined, token)

         .then((response: any) => {

       
          if (response) {
            setAvatarUser(true)
             if (user) {
               setUser({ token: user.token, success: true, user: {...user.user, avatar: avatarId ?? user.user.avatar} })
               toast.info(`Mise à jour effectuée`,{
                position: 'top-right',
                autoClose: 3000,
                icon: ({ theme, type }) => (
                  <span style={{ color: 'green' }}>
                    ✅
                  </span>
                ),
                 style: {
                  color: "green"
                }
              })
              setTimeout(()=>{
                setMsgValid(false)
              },3000)
             }
           
            }else {
              setAvatarUser(false)
          }
        })
        .catch((error) => {
          console.error('Error updating avatar:', error)
        })
    } catch (error) {
      console.error('Error updating avatar:', error)
    }
  }
 
 
  return (
    <div>
        <h2 className='h1'>Mon compte</h2>

      <div className="flex  mt-8 items-center justify-center py-10 sm:py-5  gap-5 bg-[#F1F1FF]/50  rounded-[12px] ">
        
        <Avatar ifUpdate={true} styleCss={` sm:w-[60px] sm:h-[60px]  `}
        border={` border-[10px] rounded-full border-[#FFF] `} 
          setUpdateImageUser={setUpdateImageUser}
          genre={user?.user?.personalInfo?.gender }
          avatar={newImage ? newImage : user?.user.avatar}
        />
         
        <div className='flex flex-col'>
          <div className="text-[#5754E5] text-[18px] font-bold font-poppins ">
              {user?.user?.personalInfo?.lastName} {user?.user?.personalInfo?.firstName}
          </div>
          <div className="text-[#5754E5]/30 text-[14px]">
            {user?.user?.email}
          </div>
        </div>
      </div>
      {/* </div> */}

      <ImageUserUpdate
        isOpen={updateImageUser}
        closeModal={closeModalImageUser}
        selectedImageId={avatarId}
        handleImageClick={handleImageClick}
        newImage={newImage}
        setNewImage={setNewImage}
        updateAvatar={updateAvatar}
      />
      
    </div>
  )
}
export default SettingProfileFirstPart
